import React from 'react';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Page from 'Components/Page';
import * as actions from 'Store/actions';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { useForm } from 'react-hook-form';
import { withStyles } from '@material-ui/core';
import { bindActionCreators } from 'redux';
import Link from '@material-ui/core/Link';
import FormTextField from 'Components/FormTextField';
import Button from '@material-ui/core/Button';
import * as Regex from '../regex';
import FormControl from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';

const styles = theme => ({
  container: {
    marginTop: 30,
  },
  button: {
    color: '#fff',
    display: 'block',
    textAlign: 'center',
    width: 150,
  },
  link: {
    marginTop: 20,
  },
});

function Signup({ classes, registerWithFirebase }) {
  const { register, handleSubmit, errors, watch } = useForm({
    defaultValues: {},
  });

  const tosWindow = () => {
    window.open(`${window.location.origin}/TOS?hasNav=false`, 'tos', 'width=500,height=800');
  };

  const onSignUpSubmit = async data => {
    const { firstName, lastName, email, password } = data;

    try {
      const regRes = await registerWithFirebase({
        firstName,
        lastName,
        email,
        password,
        returnPath: '/dashboard',
      });
      if (regRes.type === 'REGISTER_ERROR') {
        alert(regRes.payload.message);
      }
      return;
    } catch (err) {
      console.warn('Registration server error: ', err);
      alert(err);
      return;
    }
  };

  return (
    <Page hasNav={true}>
      <Container className={classes.container} component="main" maxWidth="sm">
        <Typography variant="h2" className={classes.login}>
          Sign Up
        </Typography>
        <div className={classes.twoFieldContainer}>
          <FormTextField
            fullWidth
            label="First Name"
            name="firstName"
            margin="normal"
            required
            error={!!errors.firstName}
            helperText={errors.firstName && errors.firstName.message}
            inputRef={register({
              required: 'Provide a first name',
              minLength: {
                value: 1,
                message: 'Name too short',
              },
            })}
            placeholder="First Name"
            className={classes.leftFormField}
          />
          <FormTextField
            fullWidth
            label="Last Name"
            name="lastName"
            margin="normal"
            required
            error={!!errors.lastName}
            helperText={errors.lastName && errors.lastName.message}
            inputRef={register({
              required: 'Provide a last name',
              minLength: {
                value: 2,
                message: 'Last name too short',
              },
            })}
            placeholder="Last Name"
          />
        </div>
        <FormTextField
          fullWidth
          label="Email"
          name="email"
          margin="normal"
          required
          error={!!errors.email}
          helperText={errors.email && errors.email.message}
          inputRef={register({
            required: 'Provide your login email',
            pattern: {
              value: Regex.email,
              message: 'Provide a valid email address',
            },
          })}
          placeholder="Enter Email"
        />
        <div className={classes.twoFieldContainer}>
          <FormTextField
            fullWidth
            label="Password"
            name="password"
            type="password"
            required
            error={!!errors.password}
            helperText={errors.password && errors.password.message}
            inputRef={register({
              required: 'Provide the password',
              minLength: {
                value: 5,
                message: 'Password too short',
              },
            })}
            className={classes.leftFormField}
          />
          <FormTextField
            fullWidth
            label="Repeat Password"
            name="rePassword"
            type="password"
            required
            error={!!errors.rePassword}
            helperText={errors.rePassword && "Passwords don't match"}
            inputRef={register({
              required: 'Repeat password',
              validate: value => value === watch('password'),
            })}
          />
        </div>
        <div className={classes.twoFieldContainer}>
          <FormControl
            control={
              <Checkbox
                name="tosCheckbox"
                className={classes.productCheckbox}
                inputRef={register({
                  required: 'Please agree to the terms of service',
                })}
                required={true}
              />
            }
            label={
              <p>
                I have read and agree to the{' '}
                <Link onClick={tosWindow} target={'tos'}>
                  terms of service
                </Link>
                .
              </p>
            }
            color="primary"
          >
            {errors.tosCheckbox && <FormHelperText>'Please agree to the terms of service'</FormHelperText>}
          </FormControl>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            className={classes.button}
            component={Link}
            onClick={handleSubmit(onSignUpSubmit)}
            style={{ marginTop: 30, textDecoration: 'none' }}
          >
            Sign Up
          </Button>
        </div>
      </Container>
    </Page>
  );
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      registerWithFirebase: actions.registerWithFirebase,
      setActiveModal: actions.setActiveModal,
    },
    dispatch,
  );
}

export default withRouter(connect(null, mapDispatchToProps)(withStyles(styles)(Signup)));
